import { type MouseEvent, forwardRef } from "react";

type Props = {
  className?: string;
  onClick?: (e: MouseEvent) => void;
};
export const GuideLocalIcon = forwardRef<SVGSVGElement, Props>(({ className, onClick }, ref) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    className={className}
    onClick={onClick}
    ref={ref}
  >
    <path
      d="M12 5.5C13.933 5.5 15.5 7.17895 15.5 9.25006C15.5 10.762 15.0085 11.1843 12.3599 15.2982C12.1861 15.5673 11.8139 15.5672 11.6401 15.2982C8.99152 11.1843 8.5 10.762 8.5 9.25006C8.5 7.17895 10.067 5.5 12 5.5ZM12 7.68753C11.1946 7.68756 10.5413 8.35449 10.5413 9.177C10.5414 9.99944 11.1947 10.6664 12 10.6665C12.8054 10.6665 13.4586 9.99945 13.4587 9.177C13.4587 8.35448 12.8054 7.68753 12 7.68753Z"
      fill="currentColor"
    />
    <path
      d="M7.625 8.375C7.54402 8.74 7.5 9.11706 7.5 9.5L7.50488 9.6875H3.78125C3.28286 9.6875 2.7889 9.90679 2.41309 10.3242C2.03518 10.7441 1.8125 11.3277 1.8125 11.9482V13.4062C1.8125 13.7687 1.51869 14.0625 1.15625 14.0625C0.793813 14.0625 0.5 13.7687 0.5 13.4062V11.9482C0.5 11.0217 0.830836 10.1204 1.4375 9.44629C2.0462 8.77007 2.88746 8.375 3.78125 8.375H7.625ZM6.40625 0.5C8.21843 0.5 9.6875 1.96907 9.6875 3.78125C9.6875 5.59343 8.21843 7.0625 6.40625 7.0625C4.59407 7.0625 3.125 5.59343 3.125 3.78125C3.125 1.96907 4.59407 0.5 6.40625 0.5ZM6.40625 1.8125C5.31894 1.8125 4.4375 2.69394 4.4375 3.78125C4.4375 4.86856 5.31894 5.75 6.40625 5.75C7.49356 5.75 8.375 4.86856 8.375 3.78125C8.375 2.69394 7.49356 1.8125 6.40625 1.8125Z"
      fill="currentColor"
    />
  </svg>
));
